import {gql} from 'react-apollo';

const API_TOKEN = gql`query {
  apiToken: apiToken
}`;


export {API_TOKEN};


// WEBPACK FOOTER //
// ./src/components/dashboard/integration/gql/query.js